import { createApiRequest } from "../common";
import { ListOrgCustomRolesRequestContent as ListOrgCustomRolesRequestContentv2, ListOrgCustomRolesResponseContent as ListOrgCustomRolesResponseContentv2 } from '@equaliq/api-model-v2';
import { ListOrgCustomRolesRequestContent, ListOrgCustomRolesResponseContent } from '@equaliq/api-model';

export const listOrgCustomRolesApi = async (request: ListOrgCustomRolesRequestContent): Promise<ListOrgCustomRolesResponseContent> => {
  const apiRequest = createApiRequest<ListOrgCustomRolesResponseContent>('post', '/orgs/roles/list');
  return apiRequest(request);
};

export const listOrgCustomRolesApiv2 = async (request: ListOrgCustomRolesRequestContentv2): Promise<ListOrgCustomRolesResponseContentv2> => {
  const apiRequest = createApiRequest<ListOrgCustomRolesResponseContentv2>('post', '/orgs/roles/list');
  return apiRequest(request);
};
